import * as React from "react";
import { useEffect } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import { ApolloProvider } from "@apollo/client";
import {
  campaignEmailTemplatePath,
  emailMarketingUnsubscribePath,
  formBuilderFormPath,
} from "__generated__/rails_routes";
import { BrowserRouter, Route, Routes } from "react-router";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getLocale } from "helpers/dateUtils/getLocale";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { PreviewFormPage } from "formBuilderPages/PreviewFormPage";
import { CampaignEmailTemplatePage } from "campaign/campaignDetails/campaignEmailTemplate/CampaignEmailTemplatePage";
import { EmailMarketingUnsubscribePage } from "campaign/emsUnsubscribe/EmailMarketingUnsubscribePage";
import { LanguageProvider } from "nav/languageChange/LanguageContext";
import "syncfusionSetup";
import { UnauthenticatedThemeProvider } from "common/theme/UnauthenticatedThemeProvider";
import { initApolloClient } from "services/apolloClient";
import type { ApolloHostConfig } from "services/apolloHostAdapter";

interface IProps {
  apolloHostConfig: ApolloHostConfig;
}

export const UnauthenticatedApp: React.FC<IProps> = ({ apolloHostConfig }) => {
  const client = initApolloClient(apolloHostConfig);

  useEffect(() => {
    window.__dismissNexlLoader?.();
  }, []);

  return (
    <Box>
      <StyledEngineProvider injectFirst>
        <ApolloProvider client={client}>
          <UnauthenticatedThemeProvider>
            <LanguageProvider>
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={getLocale()}
              >
                <BrowserRouter>
                  <Routes>
                    <Route
                      path={formBuilderFormPath(":uid")}
                      element={<PreviewFormPage />}
                    />
                    <Route
                      path={campaignEmailTemplatePath(":campaignUid")}
                      element={<CampaignEmailTemplatePage />}
                    />
                    <Route
                      path={emailMarketingUnsubscribePath(":token")}
                      element={<EmailMarketingUnsubscribePage />}
                    />
                  </Routes>
                </BrowserRouter>
              </LocalizationProvider>
            </LanguageProvider>
          </UnauthenticatedThemeProvider>
        </ApolloProvider>
      </StyledEngineProvider>
    </Box>
  );
};
